// frontend/src/useAuth.js
import { jwtDecode } from 'jwt-decode';
import { getAccessToken } from './authSession';

export const useAuth = () => {
  const token = getAccessToken();

    if (!token) {
        return { isAuthenticated: false, isStaff: false, groups: [], user: null };
    }

    try {
        const decoded = jwtDecode(token);
        return {
            isAuthenticated: true,
            isStaff: decoded.is_staff || false,
            groups: Array.isArray(decoded.groups) ? decoded.groups : [],
            user: {
                id: decoded.user_id,
                username: decoded.username
            }
        };
    } catch (e) {
        return { isAuthenticated: false, isStaff: false, groups: [], user: null };
    }
};
